import { Board } from '../types';

export const createDemoBoard = (): Board => {
  const now = Date.now();
  const dayMs = 24 * 60 * 60 * 1000;

  return {
    id: 'demo_board',
    title: 'Investigation Demo',
    createdAt: now,
    updatedAt: now,
    nodes: [
      {
        id: 'person_1',
        type: 'person',
        label: 'John Smith',
        position: { x: 100, y: 100 },
        color: '#3B82F6',
        tags: ['suspect', 'finance'],
        notesMd: '# John Smith\n\n- Age: 34\n- Occupation: Financial Analyst\n- **Known for**: Complex financial schemes\n\n## Background\nInvestigation started after suspicious transactions were flagged.',
        tsStart: now - (30 * dayMs),
        tsEnd: now - (10 * dayMs),
        attachments: []
      },
      {
        id: 'vehicle_1',
        type: 'vehicle',
        label: 'Black BMW X5',
        position: { x: 400, y: 100 },
        color: '#EF4444',
        tags: ['registered', 'surveillance'],
        notesMd: '# Vehicle Details\n\n- **License Plate**: ABC-123\n- **VIN**: 1234567890\n- **Owner**: John Smith\n- **Year**: 2020\n\nSpotted at multiple crime scenes.',
        tsStart: now - (25 * dayMs),
        tsEnd: now - (15 * dayMs),
        attachments: []
      },
      {
        id: 'location_1',
        type: 'location',
        label: 'Downtown Bank',
        position: { x: 700, y: 100 },
        color: '#10B981',
        tags: ['crime scene', 'financial'],
        notesMd: '# Downtown Bank\n\n**Address**: 123 Main Street\n\n## Significance\n- Multiple suspicious transactions\n- Security footage available\n- Last seen location',
        tsStart: now - (20 * dayMs),
        tsEnd: now - (5 * dayMs),
        attachments: []
      },
      {
        id: 'phone_1',
        type: 'phone',
        label: '555-0123',
        position: { x: 250, y: 300 },
        color: '#F59E0B',
        tags: ['burner', 'traced'],
        notesMd: '# Phone Analysis\n\n**Number**: 555-0123\n**Type**: Prepaid\n\n- Purchased with cash\n- Active for 2 weeks only\n- **Key contacts**: Multiple unknown numbers',
        tsStart: now - (14 * dayMs),
        tsEnd: now - (2 * dayMs),
        attachments: []
      },
      {
        id: 'person_2',
        type: 'person',
        label: 'Sarah Johnson',
        position: { x: 550, y: 300 },
        color: '#3B82F6',
        tags: ['witness', 'employee'],
        notesMd: '# Sarah Johnson\n\n- **Role**: Bank Teller\n- **Employment**: 5 years\n- **Status**: Cooperative witness\n\n## Statement\nProvided crucial timeline information about suspicious activities.',
        tsStart: now - (20 * dayMs),
        tsEnd: now - (3 * dayMs),
        attachments: []
      }
    ],
    edges: [
      {
        id: 'edge_1',
        source: 'person_1',
        target: 'vehicle_1',
        label: 'owns',
        color: '#6B7280',
        ts: now - (30 * dayMs),
        notesMd: 'Vehicle registered under John Smith\'s name since 2020.'
      },
      {
        id: 'edge_2',
        source: 'person_1',
        target: 'location_1',
        label: 'frequent visitor',
        color: '#6B7280',
        ts: now - (20 * dayMs),
        notesMd: 'Security footage shows multiple visits during suspicious timeframe.'
      },
      {
        id: 'edge_3',
        source: 'person_1',
        target: 'phone_1',
        label: 'used',
        color: '#F59E0B',
        ts: now - (14 * dayMs),
        notesMd: 'Phone records confirm usage pattern matching suspect behavior.'
      },
      {
        id: 'edge_4',
        source: 'phone_1',
        target: 'person_2',
        label: 'called',
        color: '#EF4444',
        ts: now - (7 * dayMs),
        notesMd: 'Critical call made just before incident. Duration: 3 minutes.'
      },
      {
        id: 'edge_5',
        source: 'person_2',
        target: 'location_1',
        label: 'works at',
        color: '#10B981',
        ts: now - (5 * 365 * dayMs), // 5 years ago
        notesMd: 'Long-term employee with access to sensitive areas and information.'
      }
    ]
  };
};